import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ol", { class: "breadcrumb" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item active" }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-current": "location" }, "Trackers")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "display-4" }, "Issue trackers", -1)
const _hoisted_4 = {
  key: 0,
  class: "row gx-5 mx-md-5"
}
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  class: "card",
  style: {"min-height":"8rem"}
}
const _hoisted_7 = { class: "card-body text-center" }
const _hoisted_8 = { class: "my-4 mb-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["TitleTag"], { title: "Trackers" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      ($setup.data)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.products, (prod) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h3", _hoisted_8, [
                      _createVNode(_component_router_link, {
                        class: "stretched-link",
                        to: '/tracker/' + prod.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(prod.prettyName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ])
                ])
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}